import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faSignInAlt, faCircleNotch, faSave, faTrash, faTimesCircle, faEdit, faSearch, faFilePdf, faStar,
  faPlus, faTimes, faExclamationTriangle, faArrowLeft, faKey, faPrint, faCog, faHistory, faEnvelope,
  faAngleUp, faFileCsv

} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faSignInAlt, faCircleNotch, faSave, faTrash, faTimesCircle, faEdit, faSearch, faFilePdf, faStar,
  faPlus, faTimes, faExclamationTriangle, faArrowLeft, faKey, faPrint, faCog, faHistory, faEnvelope,
  faAngleUp, faFileCsv
)

export default FontAwesomeIcon
